import { type BaseDto } from "@pasta/box-v2";
import { type LetterFileFolderDto } from "./letter-file-folder.dto";
import { type DocumentVersionDto } from "./document-version.dto";
import { type SignaturePositionDto } from "./signature-position.dto";

export enum LetterFileDocumentType {
  DEFAULT = "DEFAULT",
  URL = "URL",
}

export interface LetterFileDocumentDto extends BaseDto {
  type: LetterFileDocumentType;
  name: string;
  extension: string;
  url?: string;
  position: number;
  folder: LetterFileFolderDto;
  mimeType: string;
  signed?: boolean;
  pades?: boolean;
  nbPages?: number;
  documentVersions?: DocumentVersionDto[];
  signaturePositions?: SignaturePositionDto[];
  signaturePositionsCount?: number;
  modifiedSource: string;
  deletedAt?: string;
  deletedFolderName?: string;
}

export interface CreateLetterFileDocumentDto {
  type?: LetterFileDocumentType;
  name: string;
  /** id of a file uploaded with the "upload-document" usage */
  fileId?: number;
  url?: string;
  folder: number;
}

export interface UpdateLetterFileDocumentDto {
  name?: string;
  position?: number;
  folder?: number;
}

export enum LinkPurpose {
  MAIL = "MAIL",
  DOWNLOAD = "DOWNLOAD",
}
